import React, { useEffect, useRef, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import SelectBox from "../../../features/reduxworkbook/components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";
import {
  getSequentialColorSceme,
  sequentialColorArray,
} from "../../../Colors/ColorControlPanel";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import FourColorBoxComp from "../../../features/reduxworkbook/components/Aside2Components/CustomizeComponent/FourColorBoxComp";
import {
  setLevel2Properties,
  updateLevel2Properties,
} from "../../../features/reduxworkbook/WorkbookSlice";
import { useDispatch } from "react-redux";
import CustomColorControlerComp from "../../../features/reduxworkbook/components/Aside2Components/CustomizeComponent/CustomColorControlerComp";
import { getColourScemeOptions } from "../../../Colors/ColorPalettes";

const CustomSelect = ({ options, onSelect, colorScale }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);
  const labelOfColorScale = getSequentialColorSceme(colorScale);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    onSelect(option);
    setIsOpen(false);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative w-[90%] h-full" ref={dropdownRef}>
      <div
        className="p-1 border rounded border-gray-200 cursor-pointer bg-white flex items-center justify-between"
        onClick={toggleDropdown}
      >
        {labelOfColorScale
          ? labelOfColorScale.label
          : selectedOption
          ? selectedOption.label
          : "Select a color scale"}
        {isOpen ? (
          <MdKeyboardArrowUp className="relative left-1" />
        ) : (
          <MdKeyboardArrowDown className="relative left-1" />
        )}
      </div>
      {isOpen && (
        <div className="overflow-y-auto absolute z-10 w-full mt-1 bg-white border border-gray-300 shadow h-[8rem] rounded-lg flex items-start justify-between flex-col mb-4">
          {options.map((option) => (
            <div
              key={option.value}
              className=" py-2 pl-2 cursor-pointer hover:bg-gray-200 w-full rounded flex gap-2 items-center justify-between px-2"
              onClick={() => handleOptionClick(option)}
            >
              <FourColorBoxComp colors={option.colors} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default function AutoColorPoints({
  data,
  setFormattingModal,
  conditionalFormattedData,
  modalItemIndex,
  currentSheet,
  ControllerProps,
  vizType,
}) {
  const {
    rename,
    measure: measureObject,
    isColorScaleAuto,
    colorScale: reduxcolorScale,
    isColorInverted: reduxIsColorInverted,
  } = conditionalFormattedData[0] || {};
  const optionsArray = data.map((item) => {
    return {
      label: item.rename,
      value: item.columnName,
    };
  });
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState(optionsArray[0].value);
  // console.log(selectedValue);
  const [colorScale, setColorScale] = useState(
    reduxcolorScale ?? "supersetColors"
  );
  // console.log(colorScale);

  const handleValueChange = (e) => {
    // console.log(e.target.value);
    const { value } = e.target;
    if (value) {
      setSelectedValue(value);
    }
  };
  const hanldeSelectColorScale = (option) => {
    const { value } = option;
    setColorScale(value);
  };

  const saveConditionalFormatting = () => {
    const selected = data.find((item) =>
      item.dataType === "String" ? item.columnName === selectedValue : null
    );
    // console.log(selected);

    if (selected) {
      const { rename, columnName, measure, nanoId } = selected;
      //   Prepare the base value object
      const baseValue = {
        columnName,
        rename,
        isColorScaleAuto: true,
        rulesArray: [],
        formattingModalWas: "Auto",
        colorScale: colorScale,
        columnNanoId: nanoId,
      };
      // console.log(baseValue);

      if (conditionalFormattedData.length === 0) {
        // console.log("items is dispatched");
        dispatch(
          setLevel2Properties({
            reduxKey: "conditionalFormatting",
            Sheetid: currentSheet.Sheetid,
            parentKey: "customization",
            value: baseValue, // Send baseValue with or without colorScale
            itemInArray: true,
          })
        );
      } else if (conditionalFormattedData.length === 1) {
        // console.log("items is updated");
        dispatch(
          updateLevel2Properties({
            reduxKey: "conditionalFormatting",
            Sheetid: currentSheet.Sheetid,
            parentKey: "customization",
            value: baseValue,
            itemInArray: true,
            index: 0,
          })
        );
      }
      setFormattingModal(false);
    }
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      //  saveConditionalFormatting(); // Call your function here
    }
  };
  const colourSchemeType = "RANDOM";
  const colorSchemes = getColourScemeOptions(colourSchemeType);
  const colors = colorSchemes.map((scheme) => ({
    value: scheme.id,
    label: scheme.label,
    colors: scheme.colors.slice(0, 4),
  }));
  // console.log(colorSchemes);
  const customColors = colorSchemes.map((scheme) => ({
    value: scheme.id,
    label: scheme.label,
    colors: scheme.colors,
  }));
  // console.log(customColors);
  return (
    <CustomColorControlerComp
      customColorModal={true}
      setCustomColorModal={setFormattingModal}
      options={customColors}
      Sheetid={currentSheet.Sheetid}
      ControllerProps={ControllerProps}
      dispatchItemToredux={""}
      handleColorChange={hanldeSelectColorScale}
      VizchartType={vizType}
      selectedValue={selectedValue}
      handleValueChange={handleValueChange}
      optionsArray={optionsArray}
      saveConditionalFormatting={saveConditionalFormatting}
    />
  );
}
